exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-video-recorder{color:#fff;border-radius:18px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:16px;cursor:pointer}.vue-video-recorder .recorder-icon{width:64px;height:64px;background-color:#4db6ac;border-radius:50%;display:inline-block;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
